import { render } from "./App.vue?vue&type=template&id=183c6a1a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=183c6a1a&lang=css"

import exportComponent from "C:\\Users\\gaole\\Documents\\work\\dc\\www.tzspace.cn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__